


















import Vue from "vue";
import { Book } from "../types/goodreads";

export default Vue.extend({
  props: {
    book: {
      type: Object as () => Book,
      required: true
    }
  },
  computed: {
    bookLink(): string {
      return `https://www.goodreads.com/book/show/${this.book.goodreads_id}`;
    }
  }
});
